import { TOUR_ANCHORS } from 'scenes/RecoveryAI/Sandbox/tourAnchors'
import type { TourStep } from './types'

// The ordered 5-step FIRST tour over the wizard Testing-stage phone simulator,
// in playback order. Each anchorId is pulled from TOUR_ANCHORS (the shared F7
// map) so the tour and the baked `data-tour` attributes can never drift;
// title/body keys resolve under `recovery_ai.wizard.tour.steps.*` (WizardTour
// owns t()). Step 3's CTA is "Okay, show me" (still an advance, not a finish);
// the last step finishes with "Got it".
export const TOUR_STEPS: TourStep[] = [
  {
    id: 'simulator',
    anchorId: TOUR_ANCHORS.simulator,
    titleKey: 'steps.simulator.title',
    bodyKey: 'steps.simulator.body',
    // ENG-965: the opening notification sits centered ON the phone preview.
    placement: 'center',
  },
  {
    id: 'agentSettings',
    anchorId: TOUR_ANCHORS.agentSettings,
    titleKey: 'steps.controls.title',
    bodyKey: 'steps.controls.body',
  },
  {
    id: 'scenarioHeader',
    // ENG-966: "What your customer sees" must un-dim the WHOLE phone preview, not
    // just the scenario label above it — so this step deliberately spotlights the
    // phone (TOUR_ANCHORS.simulator) while keeping its own step identity/copy.
    // The card then sits beside the phone rather than over it.
    anchorId: TOUR_ANCHORS.simulator,
    titleKey: 'steps.customer.title',
    bodyKey: 'steps.customer.body',
    ctaKey: 'pager.okay_show_me',
    placement: 'right',
  },
  {
    id: 'reasoning',
    anchorId: TOUR_ANCHORS.reasoning,
    titleKey: 'steps.settings.title',
    bodyKey: 'steps.settings.body',
  },
  {
    id: 'playbackNav',
    anchorId: TOUR_ANCHORS.playbackNav,
    titleKey: 'steps.playback.title',
    bodyKey: 'steps.playback.body',
    ctaKey: 'pager.got_it',
  },
]

// Stable per-step React keys for the pager dots (never the array index).
export const TOUR_STEP_IDS: string[] = TOUR_STEPS.map(step => step.id)
